import { FunctionComponent } from 'react'
import { Button } from '@pubstack/ui/components/Button'
import { useGlobalModal } from '~/components/layout/GlobalModal'
import { GlobalModalWrapper } from '@pubstack/ui/components/GlobalModalWrapper'
import { Actions, Body, Title } from '@pubstack/ui/components/ModalLayout'
import { useDeleteAdQualityRule } from '~/api/ad-quality.api'

type DeleteAdQualityRuleModalProps = {
  ruleId: string
  ruleName: string
  scopeId: string
}

const MODAL_TRACKING_LABEL = 'settings-ad-quality-delete-modal'
const CLOSE_TRACKING_LABEL = `${MODAL_TRACKING_LABEL}-close`
const DELETE_TRACKING_LABEL = `${MODAL_TRACKING_LABEL}-delete`

export const DeleteAdQualityRuleModal: FunctionComponent<DeleteAdQualityRuleModalProps> = ({ ruleId, ruleName, scopeId }) => {
  const { close } = useGlobalModal()
  const { mutate: deleteRule } = useDeleteAdQualityRule(ruleId, scopeId, {
    successMessage: (
      <>
        <strong>{ruleName}</strong> successfully deleted.
      </>
    ),
    errorMessage: 'An error occurred while deleting the rule.',
  })

  return (
    <GlobalModalWrapper>
      <Title className="text-medium font-medium">Delete rule</Title>
      <Body className="flex flex-col gap-2">
        <p>
          You are about to delete rule <span className="font-bold">{ruleName}</span>.
        </p>
        <p>Once deleted, all the domains and categories blocklisted will potentially be monetized on your media.</p>
      </Body>
      <Actions className="flex gap-2 justify-end">
        <Button variant="tertiary" onClick={close} trackingLabel={CLOSE_TRACKING_LABEL}>
          Cancel
        </Button>
        <Button
          variant="negative"
          onClick={() => {
            deleteRule()
            close()
          }}
          trackingLabel={DELETE_TRACKING_LABEL}
        >
          Delete rule
        </Button>
      </Actions>
    </GlobalModalWrapper>
  )
}
